import Vue from "vue";
import axios from 'axios';

var baseUrl;
if (location.hostname === 'localhost') { // local
  baseUrl = "http://dev.kidsrkidschina.com"; 
} else if (location.hostname === 'http://dev.kidsrkidschina.com') { // dev
  baseUrl="http://47.93.230.5:9000";
} else if (location.hostname === '47.94.143.244' || location.hostname === 'test.kidsrkidschina.com') { // test
  baseUrl = 'https://test.kidsrkidschina.com';
} else if (location.hostname === 'www.kidsrkidschina.com' || location.hostname === 'kidsrkidschina.com') { // prd
  baseUrl = 'https://api.kidsrkidschina.com';
} else if (location.hostname === 'web-test.kidsrkidschina.com') { // oss test
  baseUrl = 'https://test.kidsrkidschina.com';
}
console.log(location.hostname, baseUrl)
const loadTime = 800;
// 添加请求拦截器
axios.defaults.timeout = 20 * 1000

axios.interceptors.request.use(config => {
  return config;
}, function (error) {
  console.log('AJAX_Error', error);

  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {

  return response;
}, function (error) {
  return Promise.reject(error);
});

export function Get (url, params) {
  axios.defaults.baseURL = baseUrl;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        if (res.data.code == '00') {
          resolve(res.data)
        } else {
          alert(res.data.msg)
          reject(res.data)
        }
      })
      .catch(err => {
        reject(err.data)
      });
  });
}
export function Post (url, params) {
  axios.defaults.baseURL = baseUrl;
  return new Promise((resolve, reject) => {
    axios
      .post(url, JSON.stringify(params), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(res => {
        if (res.data.code == '00') {
          resolve(res.data)
        } else {
          alert(res.data.msg)
          reject(res.data)
        }
      })
      .catch(err => {
        reject(err.data)
        alert('请求失败，请稍后再试')
      });
  });
}
export default {
  Get,
  Post
};



// WEBPACK FOOTER //
// ./src/config/axiosConfig.js